import { render, staticRenderFns } from "./UserTokenIpsForm.vue?vue&type=template&id=74bb120f&scoped=true&"
import script from "./UserTokenIpsForm.vue?vue&type=script&lang=ts&"
export * from "./UserTokenIpsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bb120f",
  null
  
)

export default component.exports